import numeral from 'numeral';

/* eslint-disable no-nested-ternary */
const perTicketPrice = (qty = 0) => {
  const price = (
    qty <= 11
      ? numeral(1.69)
      : qty <= 26
      ? numeral(1.59)
      : qty <= 101
      ? numeral(1.39)
      : qty <= 251
      ? numeral(1.29)
      : numeral(1.09)
  ).value();
  console.log('setting price');
  console.log(price);
  return price;
};

export default perTicketPrice;
